// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"So-z","slideIn":"To-z"};